import React, { useState } from "react"
import { reduxForm, Field } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { CheckboxField } from "components/RenderInput"
import { Col, Row } from "reactstrap"

const RestrictRegistrationForm = props => {
  const { handleSubmit, loading} = props

  return (
    <form onSubmit={handleSubmit}>
      <Row className="form-group">
        <Col xs={12}>
          <div className={"mb-3"}>
            <Field
                name={"restrict_domain_registration"}
                label={"Restrict all registrations to domains listed below. (Warning: emails not listed below will not be allowed to register)"}
                component={CheckboxField}
            />
          </div>
        </Col>
      </Row>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAMES.DOMAINS_RESTRICT_REGISTRATION // must be unique
  // validate
})(RestrictRegistrationForm)